module.exports = __webpack_public_path__ + "image-1ea755f253ca.png";